import { Action, createAction } from 'redux-actions'
import { fetchTicketById, fetchGetOrderList, fetchGetOrderinfo, fetchGetContent, fetchGetGroupWithTargetGroupsById, fetchGetGroupUsers, fetchGetCloseTicketControlStatus, fetchGenerateId, fetchGetUtcTime, fetchSaveTicket, fetchCloseTicket, fetchEscalateTicket, fetchOuterReply, fetchSubmitTicket, fetchAssignTicketById, fetchReturnTicketById, fetchArkManualSopConfig, fetchSubmitSopTicket, fetchListTagsTree, fetchListChildTags, fetchGetDefaultSubject, fetchBindTicket, fetchListRecommendCategory, fetchWaitingTicketForAgent } from "@/api/service/ticket";
import { fetchListAllTitleByUserId } from "@/api/service/common";
import { initStateData } from "./propsType";
import { getUrlArgs } from "@/utils";

export const resetState = createAction('RESET_ALLPROMOTION_STATE', () => (initStateData))
export const resetFetchState = createAction('RESET_ALLPROMOTION_FETCH_STATE')

// 新增页卡ticketdata - list
export const addPageTabs = createAction('ADD_PAGETABSLISTSUCCESS')

// 更新tabs ticket level
export const updateTicketData = createAction('UPDATE_TICKET_LEVEL_SUCCESS')

// 删除页卡ticketdata - list
export const delPageTabs = createAction('DEL_PAGETABSLISTSUCCESS')

// 页卡Activity更改
export const toggleTicketActivity = createAction('TOGGLE_TICKETACTIVITYSUCCESS')

// 改变
export const formCheckSuccess = createAction('FORM_CHECKSUCCESS')

// 订单点击触发表单验证
export const orderFormCheckSuccess = createAction('ORDER_FORM_CHECKSUCCESS')

// 更新工单 store ID
export const updataTicketId = createAction('UPDATE_TICKET_ID')

// 更新工单 处理状态
export const handleTicket = createAction('HANDLE_TICKET')

export const setTicketDataItem = createAction('SET_TICKET_DATA_ITEM')

// 更新sop
export const setTicketSopItem = createAction('SET_TICKET_SOP_ITEM')

// 更新工单页 info ticket 参数
export const setTicketInfoTicket = createAction('SET_TICKET_INFO_TICKET')

// 更新工单页 info ticketInfo 参数
export const setTicketInfoItem = createAction('SET_TICKET_INFO_ITEM')

// 更新工单页 info requester 参数
export const setTicketRequesterItem = createAction('SET_TICKET_REQUESTER_ITEM')

// 更新工单页 info complaint 参数
export const setTicketComplaintItem = createAction('SET_TICKET_COMPLAINT_ITEM')

// 更新工单页 info requester 参数
export const setTicketItem = createAction('SET_TICKET_TICKET_ITEM')

// 更新工单页 info order 参数
export const setTicketOrderItem = createAction('SET_TICKET_ORDER_ITEM')

// 查看工单详情，展示订单页卡
export const relateTicketInfo = createAction('RELATE_TICKET_INFO')

// 更新工单页 reply 参数
export const setTickeReplyInfo = createAction('SET_TICKET_REPLY_INFO')

// 设置富文本编辑器高度
export const setEditorHeight = createAction('SET_EDITOR_HEIGHT')

// 更新业务类型list
export const setBusinessTypeList = createAction('SET_BUSINESS_TYPE_LIST')

// 更新工单页 reply 索引值
export const setTickeReplyActivity = createAction('SET_TICKET_REPLY_ACTIVITY')

// 更新工单页 reply 回复区附件信息
export const setReplyAttachInfo = createAction('SET_TICKET_REPLY_ATTACH_INFO')


// 重置 OrderList
export const clearOrderList = createAction('REGET_ORDER_LIST_SUCCESS')

// 更新工单页 info ticket 参数
export const setTicketInfoOrderDetails = createAction('SET_TICKET_INFO_ORDER_DETAILS')

// 清空订单详情 
export const clearTicketInfoOrderDetails = createAction('CLEAR_TICKET_INFO_ORDER_DETAILS')

// 清除回复区数据 
export const clearTickeReplyData = createAction('CLEAR_TICKET_REPLY_DATA')

// 清除回复区数据成功 
export const clearTickeReplyDataSuccess = createAction('CLEAR_TICKET_REPLY_DATA_SUCCESS')

// 更新tag
export const setTicketTagInfo = createAction('SET_TICKET_TAG_INFO')
export const setTicketTagList = createAction('SET_TICKET_TAG_LIST')

// 是否预绑定工单
export const isPreBind = createAction('IS_PRE_BIND')

// 是否展示注册用户提示文案
export const isShowUserTips = createAction('IS_SHOW_USER_TIPS')

// 是否展示回复弹窗
export const isSingeReplyShow = createAction('IS_SINGE_REPLY_SHOW')

// 判断是否是第一次点击流转、关闭、已解决
export const isFirstCloseAndResolved = createAction('IS_FIRST_CLOSE_AND_RESOLVED')

// 更新 生成工单ID
export const setTicketInfoSuccess = createAction('SET_TICKET_INFO_SUCCESS')
export const getTicketById = function (data: { id: string; }) {
    return (dispatch: (arg0: Action<any>) => void) => {
        return fetchTicketById(data)
            .then((res) => res.data)
            .then((json) => {
                dispatch(setTicketInfoSuccess(json.data.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};


// 更新 按照ticketID获取工单信息
export const generateIdSuccess = createAction('GENERATEID_SUCCESS')
export const generateId = function (data = {}) {
    return (dispatch: (arg0: Action<any>) => void) => {
        return fetchGenerateId(data)
            .then((res) => res.data)
            .then((json) => {
                dispatch(generateIdSuccess(json.data.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 获取当前utc时间
export const getUtcTimeSuccess = createAction('GETUTCTIME_SUCCESS')
export const getUtcTime = function (data = {}) {
    return (dispatch: (arg0: Action<any>) => void) => {
        return fetchGetUtcTime(data)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getUtcTimeSuccess(json.data.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 更新子store props 数据
export const updatePropsSuccess = createAction('UPDATE_PROPS')

// 获取订单列表
export const getOrderListSuccess = createAction('GET_ORDER_LIST_SUCCESS')
export const getOrderList = function (data: Record<string, any>) {
    return (dispatch: (arg0: Action<any>) => void) => {
        return fetchGetOrderList(data)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getOrderListSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 通过订单id获取订单详情页面 organization_id 、orderId  fetchGetOrderinfo
export const getOrderinfoSuccess = createAction('GET_ORDER_INFO_SUCCESS')
export const getOrderinfo = function (data: Record<string, any>) {
    return (dispatch: (arg0: Action<any>) => void) => {
        return fetchGetOrderinfo(data)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getOrderinfoSuccess(json.data))
                // 如果是im打开需要设置cityid 
                if (getUrlArgs().imSessionId && json.data?.data?.cityId) {
                    dispatch(setTicketItem({ cityId: json.data?.data?.cityId }))
                }
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 获取回复模版列表
export const getTemplateList = function (data: Record<string, any>) {
    return fetchListAllTitleByUserId(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};

// 获取回复模版内容
export const getContent = function (data: Record<string, any>) {
    return fetchGetContent(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data?.data?.body || ''
        })
        .catch((err) => {
            console.info(err);
        });
};

// 获取工单组列表
export const getGroupWithTargetGroupsById = function (data: Record<string, any>) {
    return fetchGetGroupWithTargetGroupsById(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};

// 获取优先处理人列表
export const getGroupUsers = function (data: Record<string, any>) {
    return fetchGetGroupUsers(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};

// 获取优先处理人列表
export const getCloseTicketControlStatus = function (data: Record<string, any>) {
    return fetchGetCloseTicketControlStatus(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};

// 保存工单 
export const saveTicket = function (data: Record<string, any>) {
    return fetchSaveTicket(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};

// 发送电子邮件  
export const outerReply = function (data: Record<string, any>) {
    return fetchOuterReply(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};


// 流转  
export const escalateTicket = function (data: Record<string, any>) {
    return fetchEscalateTicket(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};


// 关单  
export const closeTicket = function (data: Record<string, any>) {
    return fetchCloseTicket(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};

// fetchSubmitTicket
export const submitTicket = function (data: Record<string, any>, parms?: string) {
    return fetchSubmitTicket(data, parms)
        .then((res) => res.data)
        .then((json) => {
            return json?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};

// fetchAssignTicketById  领取工单

export const assignTicketById = function (data: Record<string, any>) {
    return fetchAssignTicketById(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};

// fetchReturnTicketById

export const returnTicketById = function (data: Record<string, any>) {
    return fetchReturnTicketById(data)
};

export const getArkManualSopConfig = function (data: Record<string, any>) {
    return fetchArkManualSopConfig(data)
};

export const submitSopTicket = function (data: Record<string, any>, action: string) {
    return fetchSubmitSopTicket(data, action)
};


// 查看指定CR下的标签树结构
export const getListTagsTree = function (data: Record<string, any>) {
    return fetchListTagsTree(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};
// 查看某个标签（list类型）的所有子标签列表
export const getListChildTags = function (data: Record<string, any>) {
    return fetchListChildTags(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};

// 获取默认邮件标题，新版工作台用
export const getDefaultSubject = function (data?: Record<string, any>) {
    return fetchGetDefaultSubject(data)
};

// 会话绑定工单接口 fetchBindTicket
export const bindTicket = function (data: Record<string, any>) {
    return fetchBindTicket(data)
        .then((res) => res.data)
        .then((json) => {
            return json?.data || ''
        })
        .catch((err) => {
            console.info(err);
        });
};

// 获取推荐CR接口
export const listRecommendCategory = function (data?: Record<string, any>) {
    return fetchListRecommendCategory(data)
};

// 获取推荐CR接口
export const findTicketById = function (data?: Record<string, any>) {
    return fetchTicketById(data)
};

// 异步工作台弹窗获取客服下一个待处理的工单
export const getWaitingTicketForAgent = function (data?: Record<string, any>) {
    return fetchWaitingTicketForAgent(data)
};